import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { JobProcessRouteItem } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class JobProcessRouteItemService extends TmsWebBaseEditService<JobProcessRouteItem, JobProcessRouteItem> {
  constructor() {
    super('JobProcessRouteItem', $localize`Job Route Step`);
  }

  getForJob(jobId: string): Observable<JobProcessRouteItem[]> {
    return this.httpService.get<JobProcessRouteItem[]>(`${this.apiUrl}/Job/${jobId}`);
  }

  // Copies the job's process route template onto the job as its own steps.
  explode(jobId: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Explode/${jobId}`, {});
  }

  // Raises the outwork purchase order for an external step - dyeing or finishing sent
  // out. The step records the resulting line, so it cannot be ordered twice.
  raiseOutworkOrder(jobProcessRouteItemId: string): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/RaiseOutworkOrder/${jobProcessRouteItemId}`, {});
  }
}
